/**
 * Page is only accessible if user is a guest.
 */

export default function({ to, from, store }) {
    if (store.getters.apiKey) {
        return { name: 'console' };
    } else if (to.name === 'home') {
        return { name: 'login' };
    }
}
